export default __webpack_public_path__ + "static/media/project-dev-connector.37631cda.jpg";